<template>
  <div class="h-full">
    <template v-if="isShowUerInput">
      <el-tooltip
        :content="userName"
        placement="top"
        effect="dark"
        :enterable="false"
        :disabled="!disabled"
      >
        <el-input
          size="small"
          :placeholder="placeholder"
          :value="userName"
          clearable
          :disabled="disabled"
          @clear="clearName"
        >
          <template slot="append">
            <el-button type="primary" size="small" :disabled="disabled" @click="initDialog"
              >选择</el-button
            >
          </template>
        </el-input>
      </el-tooltip>
    </template>
    <el-dialog
      ref="dailog"
      append-to-body
      :close-on-click-modal="false"
      title="选择人员"
      :visible.sync="showDialog"
      top="2vh"
      class="mid-dialog"
      v-dialogDrag
    >
      <div class="w-full h-full">
        <div class="mb-20px flex justify-between items-center">
          <div class="flex">
            <el-input
              size="small"
              placeholder="请输入人员姓名"
              v-model="searchPeople"
              class="mr-10px flex-1"
              clearable
              @clear="clearSearchName"
            ></el-input>
            <el-tooltip placement="top" content="搜索" :enterable="false">
              <el-button type="primary" size="small" @click="searchPeopleFunc">搜索</el-button>
            </el-tooltip>
          </div>
        </div>
        <el-table
          ref="table"
          :data="tableData"
          border
          stripe
          height="calc(100% - 120px)"
          v-loading="tableLoading"
          :highlight-current="true"
          @selection-change="handleSelection"
          @cell-click="cellClick"
          :row-key="getRowKeys"
        >
          <el-table-column
            :reserve-selection="multiple"
            :selectable="selectable"
            type="selection"
            width="50"
            v-if="multiple"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            show-overflow-tooltip
            width="60"
          ></el-table-column>
          <el-table-column
            label="姓名"
            show-overflow-tooltip
            sortable
            prop="name"
          ></el-table-column>
          <el-table-column
            label="账户"
            show-overflow-tooltip
            sortable
            prop="userName"
          ></el-table-column>
          <el-table-column
            label="所属部门"
            width="230px"
            show-overflow-tooltip
            sortable
            prop="orgUnits"
          >
            <template slot-scope="scope">
              <el-tag
                class="mx-5px"
                size="mini"
                v-for="item in scope.row.orgUnits"
                :key="item.id"
                >{{ item.organizationUnitName }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="职务" show-overflow-tooltip sortable prop="lables">
            <template slot-scope="scope">
              <el-tag class="mx-5px" size="mini" v-for="item in scope.row.posts" :key="item.id">{{
                item.postName
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex justify-end mt-20px">
          <el-pagination
            background
            @size-change="tableSizeChange"
            @current-change="tableCurrentChange"
            :current-page.sync="pageConfig.SkipCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-size.sync="pageConfig.MaxResultCount"
            :total="total"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="text-center" v-if="multiple">
        <el-button type="primary" size="small" @click="handleOk" icon="iconfont icon-save">
          <span>确定</span>
        </el-button>
        <el-button size="small" @click="showDialog = false" icon="iconfont icon-close">
          <span>取消</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { EafOrganizationUnitUserApi } from '@wiz-api/account'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'multiple-person-select',
  components: {},
  props: {
    // 是否显示内置选择输入框
    isShowUerInput: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      default: '请选择人员',
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
    departmentId: {
      default: '',
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true,
    },
    // 禁用勾选列
    disabledIds: {
      default: () => {
        return []
      },
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      userName: '',
      searchPeople: null,
      tableLoading: false,
      pageConfig: {
        MaxResultCount: 15,
        SkipCount: 1,
      },
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      showDialog: false,
      selectionData: [],
    }
  },
  computed: {},
  watch: {
    value: {
      handler(ids) {
        if (!ids) {
          this.userName = ''
          this.$nextTick(() => {
            this.$refs.table.clearSelection()
          })
        } else {
          this.getUserName()
        }
      },
      immediate: true,
    },
    showDialog(value) {
      if (value && !this.isShowUerInput) {
        this.initDialog()
      }
    },
  },
  methods: {
    // 禁用不可选线
    selectable(row) {
      // 过滤掉自己这列选择的
      return !(this.disabledIds.indexOf(row.id) > -1)
    },
    setSelect(list) {
      this.$refs.table.clearSelection()
      list.forEach((row) => {
        this.$refs.table.toggleRowSelection(row)
      })
    },
    clearName() {
      this.userName = ''
      this.$emit('change', '')
    },
    // 获取用户名
    async getUserName() {
      const list = this.value ? this.value.split(',') : []
      if (!list.length) {
        return
      }
      //   const [err, res] = await eafOrganizationUnitUserApi.getUserDetail({ id })
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        userIdList: list,
        maxResultCount: 999,
      })
      if (!err) {
        this.userName = res.items
          .map((item) => {
            return item.name
          })
          .join()
        this.setSelect(res.items)
      }
    },
    // 初始化弹窗
    initDialog() {
      this.searchPeople = ''
      this.showDialog = true
      this.getUserList()
    },
    // 选中结果事件
    handleSelection(values) {
      if (this.multiple) {
        this.selectionData = values
      }
    },
    getRowKeys(row) {
      return row.id
    },
    cellClick(row) {
      if (!this.multiple) {
        this.userName = row.name
        this.$emit('change', row.id)
        this.showDialog = false
      }
    },
    handleOk() {
      this.userName = this.selectionData
        .map((item) => {
          return item.name
        })
        .join()
      const ids = this.selectionData
        .map((item) => {
          return item.id
        })
        .join()

      this.$emit('change', ids)
      this.showDialog = false
    },
    clearSearchName() {
      this.getUserList()
    },
    // 人员搜索
    searchPeopleFunc() {
      this.getUserList()
    },
    peopleSelectionChange(value) {
      this.multiplePeopleSelect = value
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        organizationUnitId: this.departmentId || undefined,
        includeOrgChild: true, // 是否查询该部门子部门人员
        userName: this.searchPeople,
        sorting: '',
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.tableLoading = false
      }
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getUserList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getUserList()
    },
  },
  created() {
    this.getUserList()
  },
  mounted() {
    // 强制加载dialog中的内容
    this.showDialog = true
    this.$refs.dailog.rendered = true
    this.showDialog = false
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-select-dropdown__item {
  background-color: #ffffff !important;
  overflow: hidden;
  flex-wrap: nowrap;
}
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-input__validateIcon {
  display: none;
}
.vertial-border {
  background-color: #0086f7;
}
</style>
